import { Font } from '@react-pdf/renderer';

Font.register({
  family: 'GoudyOlSt BT',
  src: '/assets/fonts/GoudyOlStBT-Bold.ttf',
  fontWeight: 'bold',
});

export const PDF_FONTS = {
  GOUDY: 'GoudyOlSt BT',
  HELVETICA: 'Helvetica',
  TIMES: 'Times-Roman',
} as const;

